// extracted by mini-css-extract-plugin
export default {"fixedHeader":"Play_fixedHeader__uxkRg","scrollContainer":"Play_scrollContainer__lCDZR"};